<template>
    <header class="hero is-light">
        <div class="hero-head">
            <nav class="navbar is-fixed-top-touch" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                    <router-link to="/" class="navbar-item is--brand">
                        <router-link tag="img" to="" src="/static/img/HPB-logo.svg" alt="HP Logo"/>
                    </router-link>
                    <button :class="[{'is-active': showMenu}, 'button', 'navbar-burger', 'is-hidden-tablet']"
                            data-target="navMenu" @click.prevent="showHideMenu($event)">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <button :class="['button', 'navbar-burger', 'custom-burger', 'is-hidden-mobile', 'is-hidden-desktop', 'is-hidden-widescreen', 'is-hidden-fullhd']"
                            data-target="tabletRightMenu" >
                        <ul @click.prevent="showHideTabletMenu" style="width:auto;">
                            <li>&nbsp;<i class="fas fa-angle-down" :class="[{'is-active':showTabletMenu}]"></i></li>
                            <li>{{ full_name }}</li>
                          <!--  <li v-if="hasBusinessLogo">
                              <figure class="image is-32x32" style="margin-right:.5em;">
                                    <img :src="business_logo">
                                </figure>
                            </li>-->
                        </ul>
                    </button>
                </div>

                <div id="tabletRightMenu"
                     :class="[{'is-active': showTabletMenu}, 'navbar-menu', 'is-hidden-mobile', 'is-hidden-desktop', 'is-hidden-widescreen', 'is-hidden-fullhd']">
                    <router-link to="/profile" class="navbar-item"
                                 @click.native="showHideTabletMenu">Your profile
                    </router-link>
                    <router-link v-if="!is_ops" to="/notifications" class="navbar-item"
                                 @click.native="showHideTabletMenu">Notification settings
                    </router-link>
                    <router-link to="/login" class="navbar-item"
                                 @click.native="showHideTabletMenu">Sign out
                    </router-link>
<!--                    <div v-if="hasMultipleBusinessRoles">-->
<!--                        <a class="navbar-item tablet-profile-switcher-menu-item" href="#"-->
<!--                           @click.prevent="showBusinessProfileSwitcher">Switch business profile</a>-->
<!--                    </div>-->
                </div>



              <div class="mobile-profile-switcher-menu-item padding-top-bottom-6">
                <p class="menu-label has-icons-left has-icons-right">
                  <span class="icon is-left is-large" @click.prevent="showHideBusinessMenu">
                    <img :src="org_logo">
                  </span>
                  <span href="#" class="profiler_name" > {{ org_name }}</span>
                </p>
                <ul v-if="hasMultipleBusinessRoles"
                    class="profiler_dropdown"  :class="[{'is-active': showBusinessMenu}]">
                  <li v-for="(business, index) in businessList">
                    <a class="business-link-item menu-label" :class="[{'active':business.selected}]" @click.prevent="switchProfile(business)"><span class="icon is-left is-large"><img
                      :src="business.image"></span><span class="bussiness_name">{{ business.name }}</span> </a>
                  </li>
                </ul>
              </div>
              <div :class="[{'is-active': showMenu}, 'navbar-menu']" id="navMenu">
                <div class="admin_portal portal_mobile">
                  <ul v-if="is_hp_admin">
                    <li :class="[{'active_tab': is_admin_active}]" >
                      <a class="" href="javascript:void(0)" @click="switchScreen">Admin</a>
                    </li>
                    <li :class="[{'active_tab': !is_admin_active}]">
                      <a class="" href="javascript:void(0)" @click="switchScreen">Portal</a>
                    </li>
                  </ul>
                </div>
                <div class="navbar-start is-hidden-desktop is-hidden-tablet">
                  <div v-for="item in menuItemsNew" v-if="(!item.businessAdminOnly || can_invite) && item.permCode[permPos]" :class="[{'is-hidden-touch is-hidden-mobile': item.hideOnMobile }]">
                      <router-link
                              v-if="item.isLink"
                              :to="`${item.destination}`" class="navbar-item"
                              >
                        <span class="icon is-left is-large">
                          <i :class="[item.icon]" v-if="!item.useIconAsImage"></i>
                          <img :src="item.icon" alt="icon" v-if="item.useIconAsImage">
                        </span>
                        <span class="nav_item_li"
                              v-text="item.text"></span>
                      </router-link>
                      <div v-else class="navbar-item has-dropdown">

                        <a @click.prevent="item.showChildren = !item.showChildren" href="#"
                             class="navbar-link has-icons-right">
                          <span class="icon is-left is-large"><i :class="[item.icon]"></i></span>
                          <span class="nav_item_li">{{ item.text }}</span>
                              <span class="icon is-small is-right"><i
                                      :class="['fas', { 'fa-plus': !item.showChildren }, { 'fa-minus': item.showChildren }]"></i></span>

                          </a>
                          <div v-for="subItem in item.subMenu" class="navbar-dropdown" v-if="item.showChildren && subItem.permCode[permPos]">
                              <router-link class="navbar-item" :to="`${subItem.destination}`" @click.native="showHideMenu($event)" v-text="subItem.text"></router-link>
                          </div>
                      </div>
                  </div>
<!--                        <div v-if="hasMultipleBusinessRoles" class="mobile-profile-switcher-menu-item">-->
<!--                            <a class="navbar-item has-text-weight-bold" href="#"-->
<!--                               @click.prevent="showBusinessProfileSwitcher">Switch business profile</a>-->
<!--                        </div>-->
                </div>
                    <div class="navbar-end is-hidden-touch" >
                      <div class="is-hoverable switch-board-link is-hidden-mobile header_top_bar_review" v-if ="!is_admin_menu_active">
                        <p v-if="!isHighestPremiumSub">Replies remaining
                          <span class="bar_review">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width:60%">
                                <span class="sr-only">70% Complete</span>
                              </div>
                            </div>
                          </span>
                          <span class="review_cal">{{reviewsRepliesSent}}/{{replies_limit}}</span>
                        </p>

                        <p v-if="!isFreeSub && !isHighestPremiumSub">Reviews Credits remaining
                          <span class="bar_review">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width:60%">
                                <span class="sr-only">70% Complete</span>
                              </div>
                            </div>
                          </span>
                          <span class="review_cal">{{reviewsRemaining}}/{{reviews_limit}}</span>
                        </p>

                        <p v-if="!isHighestPremiumSub">Invites remaining
                          <span class="bar_review">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width:30%">
                                <span class="sr-only">70% Complete</span>
                              </div>
                            </div>
                          </span>
                          <span class="review_cal">{{invitationSent}}/{{ invitation_limit }}</span>
                        </p>
                      </div>
<!--                      <div class="is-hoverable switch-board-link" v-if="is_hp_admin"> <a class="is-hidden-mobile" href="javascript:void(0)" @click="switchScreen">{{ getSwitchScreenLink }}</a></div>-->
                      <div class="navbar-item has-dropdown is-hoverable ">
                            <a class="navbar-link is-hidden-mobile " href="#" style="text-transform: capitalize;">
                               <!-- <figure v-if="hasBusinessLogo" class="image is-32x32" style="margin-right:.5em;">
                                    <img :src="business_logo">
                                </figure>-->
                              {{ full_name }}
                            </a>
                            <div :class="['navbar-dropdown is-right', 'user-menu-dropdown', { 'no-pad-bottom': hasMultipleBusinessRoles }]">
                                <router-link class="navbar-item" to="/profile">Your Profile</router-link>

                                <router-link v-if="!is_ops" class="navbar-item" to="/notifications">Notification settings
                                </router-link>

                                <router-link class="navbar-item" to="/login">Sign out</router-link>
<!--                                <a class="navbar-item profile-switcher" href="#" v-if="hasMultipleBusinessRoles"-->
<!--                                   @click.prevent="showBusinessProfileSwitcher">Switch business profile</a>-->
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </header>
</template>
<script>
  /* eslint-disable no-undef */
  import MenuItems from './../mixins/menu.js'
  import Misc from './../mixins/misc.js'
  import axios from 'axios'
  import { mapState, mapActions } from 'vuex'
  import { STORE_INVITE_STATS } from '@/store/action.types'

  export default {
    mixins: [MenuItems, Misc],
    metaInfo: {
      meta: process.env.NODE_ENV === 'production' ? [
        {
          'name': 'google-site-verification',
          'content': 'PGI8Df1akrJLYTmKQbUvveOzq-oORVhABnox7YB30zE'
        }
      ] : []
    },
    data () {
      return {
        first_name: localStorage.getItem('first_name'),
        last_name: localStorage.getItem('last_name'),
        full_name: localStorage.getItem('first_name') + ' ' + localStorage.getItem('last_name'),
        business_logo: '',
        showMenu: false,
        showTabletMenu: false,
        showBusinessMenu: false,
        can_invite: JSON.parse(localStorage.getItem('can_invite')),
        is_hp_admin: JSON.parse(localStorage.getItem('is_hp_admin')),
        is_ops: JSON.parse(localStorage.getItem('is_ops')),
        is_admin_active: JSON.parse(localStorage.getItem('is_hp_admin')),
        currentBusiness: JSON.parse(localStorage.getItem('org_id')),
        invitation_limit: '',
        replies_limit: '',
        reviews_limit: '',
        reviewsRepliesSent: 0,
        invitationSent: 0,
        reviewsRemaining: 0,
        businessSlug: localStorage.getItem('org_slug'),
        selectedBusiness: '',
        org_logo: localStorage.getItem('org_logo') === 'null' ? localStorage.getItem('industry_icon') : localStorage.getItem('org_logo'),
        org_name: '',
        businessList: [],
        subscriptionDetails: [],
        menuItemsNew: []
      }
    },
    mounted () {
      this.setBillingMenu(false)
    },
    created () {
      this.business_logo = localStorage.getItem('org_logo')
      if (this.business_logo === 'null') {
        this.business_logo = localStorage.getItem('industry_icon')
      }
      this.is_admin_active = JSON.parse(localStorage.getItem('is_admin_menu_active'))
      if (!this.is_admin_active) {
        window.events.$emit('changeMenuList', this.is_admin_active)
      }
      window.events.$on('businessLogoChanged', this.updateLogo)
      window.events.$on('profileUpdated', this.profileUpdated)
      window.events.$on('switchProfile', this.switchProfile)
      this.getAllBusinesses()
      this.getOrgName()
      this.getActiveSubscriptionDetails()
      this.getReviewInviteCount()
      this.getRemainingReviews()
      window.events.$on('updateUsageMetrix', (val) => {
        this.is_admin_menu_active = val
      })
      window.events.$on('loadHeaderStats', () => {
        this.getActiveSubscriptionDetails()
        this.getReviewInviteCount()
        this.getRemainingReviews()
      })
    },
    computed: {
      ...mapState({
        statistics: state => state.app.statistics
      }),
      getSwitchScreenLink () {
        return this.is_admin_active
      },
      hasBusinessLogo () {
        return this.business_logo !== '' && this.business_logo !== null
      },
      hasMultipleBusinessRoles () {
        const roles = JSON.parse(localStorage.getItem('roles'))
        if (typeof roles === 'undefined' || roles === null) {
          this.$router.push('/login')
        } else {
          return roles.length > 1
        }
      },
      isFreeSub () {
        return this.localBillingDetails.subscription.name === 'Free'
      },
      isHighestPremiumSub () {
        return this.localBillingDetails.subscription.name.toLowerCase() === 'p4'
      }
    },
    methods: {
      ...mapActions({
        saveInvitationStats: `app/${STORE_INVITE_STATS}`
      }),
      getOrgName () {
        let name = localStorage.getItem('org_name')
        if (name.length > 50) {
          name = name.substring(0, 50) + '...'
        }
        this.org_name = name
      },
      getReviewInviteCount () {
        axios.get(`/${this.currentBusiness}/review-invites?page=0`)
          .then(response => {
            this.invitationSent = 0
            if (typeof response.data.invitationStats.pending !== 'undefined') {
              this.invitationSent = response.data.invitationStats.pending
              this.saveInvitationStats(Object.assign(this.statistics, {
                invites: {
                  remaining: this.invitationSent
                }
              }))
            }
            localStorage.setItem('mailType', JSON.stringify(response.data.selectedTemplate))
          })
      },
      /**
       * Makes an api call to get reviews count statistics for org
       * @returns {void}
       */
      getReviewsCountStats () {
        axios.get(`/${this.getBusinessSlug}/reviews-count-stats`)
          .then((stats) => {
            this.reviewsRepliesSent = stats.data.reviewsRepliesInSubs
          })
      },
      /**
       * Makes an api call to get reviews count statistics for org
       * @returns {void}
       */
      getRemainingReviews () {
        axios.get(`/${this.businessSlug}/remaining-reviews`)
          .then((stats) => {
            this.reviewsRepliesSent = stats.data.review_replies_remaining
            this.reviewsRemaining = stats.data.total_reviews_remaining
            localStorage.reviewRatingAvg = stats.data.reviewRatingAvg
            localStorage.totalReviews = stats.data.total_reviews
            localStorage.firstActiveReviewDate = stats.data.firstActiveReviewDate
            window.events.$emit('firstActiveReviewDateLoaded')
          })
      },
      getActiveSubscriptionDetails () {
        axios.get(`/subscriptions/${this.businessSlug}/get-active-subscription-details`)
          .then(({data}) => {
            this.invitation_limit = data.invitation_limit
            this.replies_limit = data.replies_limit
            this.reviews_limit = data.reviews_limit
          })
      },

      getAllBusinesses () {
        const roles = JSON.parse(localStorage.getItem('roles'))
        const currentOrg = parseInt(localStorage.getItem('org_id'))
        for (let i = 0; i < roles.length; i++) {
          this.businessList.push({
            id: roles[i]['org_id'],
            name: roles[i]['org_name'],
            image: roles[i]['org_logo'] ? roles[i]['org_logo'] : '/static/' + roles[i]['industry_icon'],
            selected: currentOrg === roles[i]['org_id']
          })
        }
      },
      switchScreen () {
        this.is_admin_active = !JSON.parse(localStorage.getItem('is_admin_menu_active'))
        localStorage.setItem('is_admin_menu_active', this.is_admin_active)
        this.is_admin_menu_active = JSON.parse(localStorage.getItem('is_admin_menu_active'))
        window.events.$emit('changeMenuList', this.is_admin_active)
        if (this.is_admin_active) {
          this.$router.push('/reviews-listing')
        } else {
          this.$router.push('/')
        }
      },
      profileUpdated () {
        this.first_name = localStorage.getItem('first_name')
        this.last_name = localStorage.getItem('last_name')
      },
      showOpsOnlyMenu (menuItem) {
        return (menuItem.opsOnly === undefined || !menuItem.opsOnly)
      },
      showHPAdminOnlyMenu () {
        return (this.is_hp_admin)
      },
      showOtherAdminMenus (menuItem) {
        return (!this.is_hp_admin && menuItem.hpAdminOnly === undefined)
      },
      showHideTabletMenu () {
        this.showTabletMenu = !this.showTabletMenu
      },
      showHideBusinessMenu () {
        this.showBusinessMenu = !this.showBusinessMenu
      },
      showHideMenu (event) {
        this.showMenu = !this.showMenu
      },
      hideMobileMenu () {
        this.showMenu = false
      },
      showBusinessProfileSwitcher () {
        const roles = JSON.parse(localStorage.getItem('roles'))
        const currentOrg = parseInt(localStorage.getItem('org_id'))
        let businessList = []

        for (let i = 0; i < roles.length; i++) {
          businessList.push({
            id: roles[i]['org_id'],
            name: roles[i]['org_name'],
            image: roles[i]['org_logo'] ? roles[i]['org_logo'] : '/static/' + roles[i]['industry_icon'],
            selected: currentOrg === roles[i]['org_id']
          })
        }

        let options = {
          'title': 'Switch business profile',
          'body': '',
          'btn_action_title': 'SWITCH PROFILE',
          'show_btns': true,
          'task': 'switchProfile',
          'producer': {},
          'radioOptions': businessList
        }
        modal(options)
      },
      switchProfile (props) {
        let promises = []
        if (props.id) {
          const currentOrg = parseInt(localStorage.getItem('org_id'))
          if (currentOrg !== props.id) {
            const roles = JSON.parse(localStorage.getItem('roles'))
            for (let i = 0; i < roles.length; i++) {
              if (roles[i]['org_id'] === props.id) {
                promises.push(new Promise((resolve, reject) => {
                  localStorage.removeItem('bizSources')
                  localStorage.setItem('org_id', roles[i]['org_id'])
                  localStorage.setItem('org_name', roles[i]['org_name'])
                  localStorage.setItem('org_logo', roles[i]['org_logo'])
                  localStorage.setItem('org_slug', roles[i]['org_slug'])
                  localStorage.setItem('org_industry_id', roles[i]['org_industry_id'])
                  localStorage.setItem('can_invite', JSON.stringify(roles[i]['role_slug'] === 'business-admin'))
                  localStorage.setItem('industry_icon', props.image)
                  localStorage.setItem('org_join_date', roles[i]['org_join_date'])
                  localStorage.setItem('role', roles[i]['role'])
                  localStorage.setItem('org_reviews', JSON.stringify(roles[i]['org_reviews']))
                  this.canBusinessAddUsers(roles[i]['org_id'])
                    .then(() => {
                      axios.get(`/${roles[i]['org_slug']}/billing-details`)
                        .then(({data}) => {
                          localStorage.setItem('billingDetails', JSON.stringify(data))
                          resolve()
                        })
                    })
                }))
              }
            }
          }
          if (promises.length > 0) {
            Promise.all(promises)
              .then(() => {
                this.is_admin_active = false
                localStorage.setItem('is_admin_menu_active', this.is_admin_active)
                if (this.$route.path === '/') {
                  window.events.$emit('update-review-dashboard')
                  setTimeout(() => {
                    location.reload()
                  }, 400)
                } else {
                  window.location.href = '/'
                }
              })
          }
        }
      },
      async canBusinessAddUsers (orgId) {
        try {
          let canBusinessAddUsers = await axios(`/auth/can-add-more-business-users/${orgId}`)
          localStorage.setItem('can_add_more_users', JSON.parse(canBusinessAddUsers.data.can_add_more_users))
        } catch (error) {
          flash('An unexpected error occurred. Please try again later.', 'is-danger')
        }
        window.events.$emit('businessLogoChanged')
      },
      updateLogo () {
        this.business_logo = localStorage.getItem('org_logo')
      },
      setBillingMenu (val) {
        let menu = {}
        if (val) {
          menu = {
            isLink: false, // is a router link
            destination: '', // router target
            text: 'Billing', // menu label to display
            mobileOnly: false, // whether or not this menu item should be rendered for Mobile
            icon: 'fas far fa-money-bill-alt', // icon to render
            isAdminActive: false,
            businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
            showChildren: false,
            permCode: [1, 0, 1, 0],
            subMenu: [
              {
                destination: '/billing',
                text: 'Billing Details',
                isAdminActive: false,
                permCode: [0, 0, 1, 0]
              },
              {
                destination: '/eft-manual-matching',
                text: 'EFT Manual Matching',
                isAdminActive: true,
                hpAdminOnly: true, // this menu item will only be available to HP hp admin
                permCode: [1, 0, 0, 0]
              },
              {
                destination: '/invoices',
                text: 'Invoices',
                isAdminActive: true,
                hpAdminOnly: true, // this menu item will only be available to HP hp admin
                permCode: [1, 0, 0, 0]
              }
            ]
          }
          // this.menuItems[15] = menu
        } else {
          menu = {
            isLink: true, // is a router link
            destination: '/billing', // router target
            text: 'Billing', // menu label to display
            mobileOnly: false, // whether or not this menu item should be rendered for Mobile
            icon: 'fas far fa-money-bill-alt', // icon to render
            isAdminActive: false,
            businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
            permCode: [0, 0, 1, 0]
          }
          this.menuItems[15] = menu
        }
        this.menuItems.forEach((item, index) => {
          if (index === 15) {
            this.menuItemsNew.push(menu)
          } else {
            this.menuItemsNew.push(item)
          }
        })
      }
    },
    destroyed () {
      window.events.$off('updateUsageMetrix')
      window.events.$off('loadHeaderStats')
    },
    watch: {
      '$route' () {
        this.hideMobileMenu()
      }
    }
  }
</script>
<style scoped>
    .navbar-brand {
        padding: 10px;
    }

    a.navbar-item, a.navbar-item > img {
        background: none !important;
    }

    header {
        background-color: #565e65 !important;
    }

    .navbar-link::after {
        border: 1px solid #ffffff;
        border-right: 0;
        border-top: 0;
    }

    .navbar-dropdown {
        background-color: #565e65;
        color: #ffffff;
    }

    .navbar-dropdown a.navbar-item:hover, .navbar-dropdown a.navbar-link:hover {
        background-color: #30AAE1;
        color: #ffffff;
    }

    .navbar-item.has-dropdown:hover .navbar-link {
        background-color: #677179;
    }

    @media screen and (min-width: 1024px) {
        .navbar-dropdown a.navbar-item {
            padding-right: 0 !important;
        }
    }

    .navbar-burger {
        background-color: #565e65;
        border: 0;
    }

    .navbar-burger span {
        background-color: #ffffff;
    }

    .navbar-start .navbar-item {
        background-color: #565e65;
        color: #fff;
        border: 0;
    }

    .hero.is-light a:not(.button):not(.dropdown-item):not(.tag), .hero.is-light strong {
        color: #fff;
    }

    .navbar-menu {
        padding: 0
    }

    .navbar-item {
        font-size: 1rem;
    }

    .navbar-dropdown {
        margin-left: 3%;
        border-radius: 0;
        box-shadow: none;
    }

    .navbar-start {
        background-color: #565e65;
    }

    .navbar-start > a.navbar-item {
        padding: 15px;
        margin-left: 20px;
        margin-right: 15px;
        border-bottom: 1px solid #7e8b95;
    }

    .navbar-start > a.navbar-item:last-child {
        border: 0;
    }

    .navbar-start > .navbar-item.has-dropdown {
        margin-left: 20px;
        margin-right: 15px;
        border-bottom: 1px solid #7e8b95;
    }

    .navbar-start > .navbar-item.has-dropdown > .navbar-link {
        padding-right: 0.5em;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .navbar-start > .navbar-item.has-dropdown > .navbar-dropdown {
        padding-top: 0;
    }

    .navbar-start > a.router-link-exact-active {
        color: #2aabe1 !important;
    }

    .navbar-burger > ul {
        list-style-type: none;
        display: block;
        float: right;
        width: 25rem;
    }

    .navbar-burger > ul > li {
        display: block;
        float: right;
        height: 32px;
        line-height: 32px;
    }

    .custom-burger {
        width: 30rem !important;
        color: #ffffff;
    }

    @media screen and (max-width: 767px) {

        .navbar-start {
            margin-left: 20px;
            margin-right: 20px;
        }

        .navbar-item.has-dropdown:hover .navbar-link {
            background-color: #565e65;
        }

        .navbar-item.has-dropdown:hover > a.navbar-link.has-icons-right {
            color: #2aabe1 !important;
        }

        .navbar-start.is-hidden-desktop.is-hidden-tablet > div {
            padding-top: 10px;
            padding-bottom: 10px;
        }

        .navbar-start.is-hidden-desktop.is-hidden-tablet > div:not(:last-child) {
            border-bottom: 1px solid #7e8b95;
        }
    }

    @media screen and (max-width: 1023px) {
        .hero.is-light .navbar-menu {
            background-color: #565e65;
        }
    }

    .navbar-end.is-hidden-touch > .navbar-dropdown {
        padding-top: 0;
        padding-bottom: 0;
    }

    .navbar-end.is-hidden-touch > .navbar-item > .navbar-dropdown {
        background-color: #ffffff;
        border: 1px solid #dbdbdb;
        border-top: 3px solid #2aabe1;
        width:205px;
    }

    .navbar-end.is-hidden-touch > .navbar-item > .navbar-dropdown > a.navbar-item {
        color: #58595b;
        padding-top:5px;
        padding-bottom:5px;
    }

    .navbar-end.is-hidden-touch > .navbar-item > .navbar-dropdown > a.navbar-item:hover {
        color: #58595b;
        background-color: #ffffff;
        padding-top:5px;
        padding-bottom:5px;
    }

    .profile-switcher {
        border-top: 1px solid #dbdbdb;
        margin-top: 0.5rem;
        padding-top: 1rem;
        margin-bottom: 0;
        background-color: #f5f5f5;
        padding-bottom: 1rem;
    }

    .navbar-end.is-hidden-touch > .navbar-item > .navbar-dropdown > a.navbar-item.profile-switcher:hover {
        background-color: #f5f5f5;
        color: #58595b;
    }

    .no-pad-bottom {
        padding-bottom: 0;
    }

    .navbar-end.is-hidden-touch a {
        font-size: 0.9rem;
    }

    .tablet-profile-switcher-menu-item, .mobile-profile-switcher-menu-item, .mobile-profile-switcher-menu-item > a {
        background-color: #616971 !important;
    }

    .navbar.is-fixed-top-touch {
        background-color: #565e65 !important;
    }
    .switch-board-link {
        color: #fff;
        display: flex;
        align-items: center;
    }

    .switch-board-link a {
        cursor: pointer;
        font-style: italic;
    }
    .header_top_bar_review{font-size: 8px;color: #58595b;display:flex;position: relative;}
    .header_top_bar_review p{display:flex;margin-right: 20px; font-size: 10px}
    .header_top_bar_review .progress {
      margin-top: 0.3rem;
      height: 4px;
      overflow: hidden;
      background-color: #f0f1f2;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
      box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    }
    .header_top_bar_review .progress-bar {
      float: left;
      width: 0%;
      height: 100%;
      font-size: 12px;
      line-height: 20px;
      color: #fff;
      text-align: center;
      background-color: #cef0ff;
      -webkit-transition: width .6s ease;
      -o-transition: width .6s ease;
      transition: width .6s ease;
    }
    span.bar_review {
      width: 60px;
      margin:0px 5px;
    }
    .navbar-brand .navbar-item{padding:0px;}
    .navbar-brand{min-height: 2.7rem;padding:0px;}
    .header_top_bar_review:after {
      content: '';
      width: 1px;
      height: 25px;
      position: absolute;
      top: 50%;
      right: 0;
      background: rgba(138, 140, 145, 0.32);
      top: 50%;
      transform: translateY(-50%);
    }
    header.hero.is-light nav.navbar.is-fixed-top-touch {
      border-bottom: solid 1px rgba(138, 140, 145, 0.32);
    }
    div#navMenu .navbar-end a.navbar-link {
      padding-right: 3.5em;
    }
    .hero.is-light .user-menu-dropdown {padding: 0 !important;}
    .hero.is-light .user-menu-dropdown a {
      padding: 10px !important;
    }
    .hero.is-light .user-menu-dropdown a:hover {
      background-color: rgba(103, 113, 122, 0.1) !important;
      color: #30aae1 !important;
    }
    @media screen and (max-width: 1024px) {
      #sideBar {
        margin-top: 0px !important;
      }
    }
    @media screen and (min-width: 1024px){
    .navbar {
      min-height: 2.7rem;
    }
      .left_column .menu-label .icon.is-pulled-right {
        position: absolute;
        top: 0;
        right: 0;
      }

      .left_column .menu-label .icon.is-pulled-right i {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }

</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue